export default "__VITE_ASSET__ByCY9ub5__"